export function extractAndDeleteProductsFromSections(sections) {
  const products = [];
  sections.forEach(section => section.fops &&
    section.fops
      .filter(fop => fop.product)
      .forEach(fop => {
        products.push(fop.product);
        delete fop.product; // eslint-disable-line
      })
  );
  return products;
}

export function extractAndDeleteProductsFromFopCollection(fopCollection) {
  return (fopCollection && fopCollection.sections)
    ? extractAndDeleteProductsFromSections(fopCollection.sections)
    : [];
}
